export default {
  data() {
    return {
      localStorageKey: ""
    }
  },
  created() {
    const positionRelativeTop = localStorage.getItem(this.localStorageKey)
    if(positionRelativeTop) {
      setTimeout(() => {
        window.scroll({
          top: positionRelativeTop,
          left: 0,
          behavior: 'smooth'
        });
        localStorage.removeItem(this.localStorageKey);
      }, 800);
    }
  },
  methods: {
    /**
     *
     * @param {HTMLElement} element - Element that will calculate the distance from the top
     * @param {String} localStorageKey - Localstorage key that will save the distance of the "element" from the top of the page
     */
    setLocalStorageTopDistance({ target: element }) {
      const positionRelativeTop = window.pageYOffset + element.getBoundingClientRect().top - 10 // Calculating the distance from the top
      localStorage.setItem(this.localStorageKey, positionRelativeTop)
    },
  },
}
